var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7075 12.704C20.5923 11.9036 19.9743 11.2796 19.1787 11.0936C16.0863 10.3688 15.3111 8.58799 15.1803 6.61279C14.6319 6.51079 13.6563 6.40039 12.0003 6.40039C10.3443 6.40039 9.36868 6.51079 8.82028 6.61279C8.68948 8.58799 7.91428 10.3688 4.82188 11.0936C4.02628 11.2808 3.40828 11.9036 3.29308 12.704L2.69668 16.8344C2.48668 18.2888 3.55468 19.6004 5.04028 19.6004H18.9603C20.4447 19.6004 21.5139 18.2888 21.3039 16.8344L20.7075 12.704ZM12.0003 16.5908C10.3263 16.5908 8.96908 15.2468 8.96908 13.5908C8.96908 11.9348 10.3263 10.5908 12.0003 10.5908C13.6743 10.5908 15.0315 11.9348 15.0315 13.5908C15.0315 15.2468 13.6731 16.5908 12.0003 16.5908ZM23.9403 5.20039C23.9115 3.40039 19.3299 0.401591 12.0003 0.400391C4.66948 0.401591 0.0878785 3.40039 0.0602785 5.20039C0.0326785 7.00039 0.0854786 9.34279 3.10228 8.95279C6.63148 8.49559 6.41428 7.26319 6.41428 5.50159C6.41428 4.27279 9.28468 3.97639 12.0003 3.97639C14.7159 3.97639 17.5851 4.27279 17.5863 5.50159C17.5863 7.26319 17.3691 8.49559 20.8983 8.95279C23.9139 9.34279 23.9679 7.00039 23.9403 5.20039Z",
    fill: "#B02526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.38b7c0f0f2999b9886420f13837e11ab.svg";
export { ForwardRef as ReactComponent };